import { render, staticRenderFns } from "./SubscriptionBlocked.vue?vue&type=template&id=0281bb65&scoped=true"
import script from "./SubscriptionBlocked.vue?vue&type=script&lang=js"
export * from "./SubscriptionBlocked.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionBlocked.vue?vue&type=style&index=0&id=0281bb65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281bb65",
  null
  
)

export default component.exports